// axios
import axios from 'axios'
//
// const baseURL = 'http://localhost:7776'
// const baseURL = 'http://staging.axesspoint3.com:7778'
const baseURL = 'https://axesspoint3.com'
// const baseURL = 'http://beta.axesspoint3.com:7776'

export default axios.create({
  baseURL
  // You can add your headers here
})
